export default __webpack_public_path__ + "static/media/screens_mobile_small.4ae710d6.png";